import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IGetGroupSetDetailInfoResult, IGroupSetGroupInfo } from '../../models/IGroupSetInfo';
import { createBaseRestConfig } from '../GroupSetsServerApiHelper';


export interface IGetGroupSetParams extends IGetItemsParams {
    groupSetId: string;
}

export interface IGetGroupSetResult extends IResult {
    localId?: number;
    groupCount?: number;
    id: string;
    name?: string;
    group?: IGroupSetGroupInfo[];
}

export async function getGroupSetById(groupSetId: string): Promise<IGetGroupSetDetailInfoResult> {
    const config: RestApiRequestConfig<{}, {}> = {
        ...createBaseRestConfig(),
        httpMethod: 'GET',
        endpoint: `groupsets/` + groupSetId,
    };

    let response = makeRestApiRequest<{}, any, {}>(config);
    return response.then((result: any) => {
        const groupInfo: IGetGroupSetDetailInfoResult = {
            ...result.groupSet,
            contentType: 'groupset'
        };
        return groupInfo;
    }, (error) => Promise.reject(error));
}